var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.004 4.033H17V2H15V4.024H9V2H7V4.015H6C4.344 4.015 3 5.357 3 7.014V19C3 20.657 4.343 22 6 22H18C19.657 22 21 20.657 21 19V7.034C21 5.379 19.659 4.035 18.004 4.033ZM6 6.024H18.002C18.552 6.025 19 6.483 19 7.034V9H5V7.015C5 6.463 5.449 6.024 6 6.024ZM18 20H6C5.449 20 5 19.551 5 19V11H19V19C19 19.551 18.551 20 18 20ZM10 16H7V13H10V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarM);
export default __webpack_public_path__ + "static/media/calendar-M.c0fedc86b4c1b221ac53eb2daf69b0fa.svg";
export { ForwardRef as ReactComponent };